import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axiosHttp from 'services/axiosHttp';

export const fetchQrLocationList = createAsyncThunk(
  'qrLocationList/fetchQrLocationList',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await axiosHttp.get('lcqr/getqrlocations', { params });
      if (response.data && response.data.success) {
        return response.data.data;
      } else {
        return rejectWithValue(response.data?.message || 'Failed to fetch QR Locations');
      }
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || 'Something went wrong');
    }
  }
);

const qrLocationListSlice = createSlice({
  name: 'qrLocationList',
  initialState: {
    data: [],
    isLoading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchQrLocationList.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchQrLocationList.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(fetchQrLocationList.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      });
  },
});

export default qrLocationListSlice.reducer;